var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalcNotebookIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.1099,
    cy: 47.1104,
    r: 28.1104,
    fill: "#E5E7ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1982 29.5C25.6176 28.9787 26.0553 28.4728 26.5103 27.983V29.5H25.1982Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7495 34.9691C22.156 34.1217 22.6036 33.2978 23.0899 32.5H48.7495V35.5H21.7495V34.9691Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5594 41.5C19.7663 40.4788 20.0285 39.4777 20.3427 38.5H32.2495V41.5H19.5594Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0022 47.5C19.0004 47.3703 18.9995 47.2405 18.9995 47.1104C18.9995 46.2302 19.04 45.3595 19.1191 44.5H50.2495V47.5H19.0022Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7289 53.5C19.5008 52.5187 19.3241 51.5177 19.2018 50.5H32.2495V53.5H19.7289Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8701 59.5C21.8295 59.4174 21.7893 59.3347 21.7495 59.2516V56.5H48.7495V59.5H21.8701Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8486 65.5C25.029 64.5532 24.2715 63.5511 23.5826 62.5H32.2495V65.5H25.8486Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1239 71.5C31.6117 70.631 30.188 69.6254 28.8696 68.5H50.2495V71.5H33.1239Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4623 74.5C51.4209 74.9715 49.2945 75.2207 47.1099 75.2207C44.9253 75.2207 42.7988 74.9715 40.7575 74.5H53.4623Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3502 68.5C64.0317 69.6254 62.608 70.631 61.0958 71.5H51.7495V68.5H65.3502Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6372 62.5C69.9482 63.5511 69.1908 64.5532 68.3711 65.5H44.2495V62.5H70.6372Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6138 56.5C73.2493 57.5289 72.8266 58.5302 72.3496 59.5H60.7495V56.5H73.6138Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.018 50.5C74.8957 51.5177 74.719 52.5187 74.4909 53.5H72.7495V50.5H75.018Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1007 44.5C75.1798 45.3595 75.2203 46.2302 75.2203 47.1104C75.2203 47.2405 75.2194 47.3703 75.2176 47.5H51.7495V44.5H75.1007Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.877 38.5C74.1913 39.4777 74.4535 40.4788 74.6603 41.5H44.2495V38.5H73.877Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1299 32.5C71.7171 33.4634 72.2481 34.4649 72.7181 35.5H60.7495V32.5H71.1299Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2257 26.5C67.2284 27.4305 68.1632 28.4332 69.0216 29.5H62.6343V26.5H66.2257Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1935 20.5C58.3877 21.2488 60.4599 22.2614 62.372 23.5H51.7495V20.5H56.1935Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0263 20.5H50.2495V23.5H31.8478C33.7599 22.2614 35.832 21.2488 38.0263 20.5Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7495 26.5H48.387V29.5H60.7495V26.5Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2495 32.5H50.2495V35.5H59.2495V32.5Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7495 38.5H33.7495V41.5H42.7495V38.5Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2495 50.5H33.7495V53.5H71.2495V50.5Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2495 56.5H50.2495V59.5H59.2495V56.5Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7495 62.5H33.7495V65.5H42.7495V62.5Z",
    fill: "#617080",
    fillOpacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9995 62.5H42.9995V65.5H33.9995V62.5Z",
    fill: "#152C73"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4995 62.5H68.5793V65.5H44.4995V62.5Z",
    fill: "#617080"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0793 62.5H79.0793V65.5H70.0793V62.5Z",
    fill: "#D56CCA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9995 68.5H51.9995V71.5H39.9995V68.5Z",
    fill: "#152C73"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4995 68.5H62.546V71.5H53.4995V68.5Z",
    fill: "#617080"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M64.046 68.5H73.046V71.5H64.046V68.5Z",
    fill: "#D56CCA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20.5H32V23.5H23V20.5Z",
    fill: "#152C73"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 20.5H38.5V23.5H33.5V20.5Z",
    fill: "#617080"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20.5H50.2771V23.5H40V20.5Z",
    fill: "#D56CCA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26.5H34.3438V29.5H19V26.5Z",
    fill: "#152C73"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8438 26.5H50.7166V29.5H35.8438V26.5Z",
    fill: "#617080"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2166 26.5H58.0381V29.5H52.2166V26.5Z",
    fill: "#D56CCA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4995 37.25C53.4995 35.4551 50.5894 34 46.9995 34C43.4097 34 40.4995 35.4551 40.4995 37.25V39.85H46.6745C46.854 39.85 46.9995 39.9955 46.9995 40.175C46.9995 40.3545 46.854 40.5 46.6745 40.5H37.2495C35.4546 40.5 33.9995 43.4101 33.9995 47C33.9995 50.5899 35.4546 53.5 37.2495 53.5H39.8495C39.8495 51.8664 39.9511 50.6162 40.1893 49.6634C40.2739 49.3249 40.3765 49.0209 40.4995 48.7487C40.7246 48.2505 41.0178 47.8591 41.3934 47.5587C41.9692 47.098 42.699 46.8837 43.5631 46.7789C44.4205 46.675 45.4524 46.675 46.6566 46.675H46.6745C48.0621 46.675 49.1795 46.6746 50.0872 46.5754C50.9944 46.4762 51.6477 46.2821 52.1279 45.9263C52.5998 45.5768 52.9437 45.0416 53.1698 44.1757C53.3978 43.3025 53.4995 42.117 53.4995 40.5V37.25ZM43.4244 38.4528C44.0886 38.4528 44.6269 37.9144 44.6269 37.2503C44.6269 36.5861 44.0886 36.0478 43.4244 36.0478C42.7603 36.0478 42.2219 36.5861 42.2219 37.2503C42.2219 37.9144 42.7603 38.4528 43.4244 38.4528Z",
    fill: "#D56CCA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4995 45.1975C53.2572 45.7261 52.9352 46.1373 52.5148 46.4487C51.8982 46.9054 51.1093 47.1175 50.1579 47.2215C49.2109 47.325 48.0589 47.325 46.6914 47.325H46.6745C45.4489 47.325 44.4555 47.3255 43.6414 47.4242C42.8298 47.5226 42.2392 47.7145 41.7994 48.0663C41.3644 48.4143 41.0374 48.9509 40.8199 49.821C40.6011 50.6963 40.4995 51.8836 40.4995 53.5V56.75C40.4995 58.5449 43.4097 60 46.9995 60C50.5894 60 53.4995 58.5449 53.4995 56.75V54.15H47.3245C47.145 54.15 46.9995 54.0045 46.9995 53.825C46.9995 53.6455 47.145 53.5 47.3245 53.5H56.7495C58.5444 53.5 59.9995 50.5899 59.9995 47C59.9995 43.4101 58.5444 40.5 56.7495 40.5H54.1495C54.1495 42.133 54.0481 43.385 53.7987 44.3399C53.7165 44.655 53.6174 44.9401 53.4995 45.1975ZM51.7769 56.7503C51.7769 57.4144 51.2386 57.9528 50.5744 57.9528C49.9103 57.9528 49.3719 57.4144 49.3719 56.7503C49.3719 56.0861 49.9103 55.5478 50.5744 55.5478C51.2386 55.5478 51.7769 56.0861 51.7769 56.7503Z",
    fill: "#D56CCA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4995 39.5H37.2495C35.7692 39.5 34.6983 40.674 34.057 41.9566C33.3858 43.299 32.9995 45.0835 32.9995 47C32.9995 48.9165 33.3858 50.701 34.057 52.0434C34.6983 53.326 35.7692 54.5 37.2495 54.5H39.4995V56.75C39.4995 58.2303 40.6735 59.3012 41.9561 59.9425C43.2985 60.6137 45.083 61 46.9995 61C48.916 61 50.7005 60.6137 52.0429 59.9425C53.3255 59.3012 54.4995 58.2303 54.4995 56.75V54.5H56.7495C58.2298 54.5 59.3007 53.326 59.942 52.0434C60.6132 50.701 60.9995 48.9165 60.9995 47C60.9995 45.0835 60.6132 43.299 59.942 41.9566C59.3007 40.674 58.2298 39.5 56.7495 39.5H54.4995V37.25C54.4995 35.7697 53.3255 34.6988 52.0429 34.0575C50.7005 33.3863 48.916 33 46.9995 33C45.083 33 43.2985 33.3863 41.9561 34.0575C40.6735 34.6988 39.4995 35.7697 39.4995 37.25V39.5ZM43.6269 37.2503C43.6269 37.3621 43.5363 37.4528 43.4244 37.4528C43.3126 37.4528 43.2219 37.3621 43.2219 37.2503C43.2219 37.1384 43.3126 37.0478 43.4244 37.0478C43.5363 37.0478 43.6269 37.1384 43.6269 37.2503ZM50.7769 56.7503C50.7769 56.8621 50.6863 56.9528 50.5744 56.9528C50.4626 56.9528 50.3719 56.8621 50.3719 56.7503C50.3719 56.6384 50.4626 56.5478 50.5744 56.5478C50.6863 56.5478 50.7769 56.6384 50.7769 56.7503Z",
    stroke: "#E5E7ED",
    strokeWidth: 2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4995 37.25C53.4995 35.4551 50.5894 34 46.9995 34C43.4097 34 40.4995 35.4551 40.4995 37.25V39.85H46.6745C46.854 39.85 46.9995 39.9955 46.9995 40.175C46.9995 40.3545 46.854 40.5 46.6745 40.5H37.2495C35.4546 40.5 33.9995 43.4101 33.9995 47C33.9995 50.5899 35.4546 53.5 37.2495 53.5H39.8495C39.8495 51.8664 39.9511 50.6162 40.1893 49.6634C40.2739 49.3249 40.3765 49.0209 40.4995 48.7487C40.7246 48.2505 41.0178 47.8591 41.3934 47.5587C41.9692 47.098 42.699 46.8837 43.5631 46.7789C44.4205 46.675 45.4524 46.675 46.6566 46.675H46.6745C48.0621 46.675 49.1795 46.6746 50.0872 46.5754C50.9944 46.4762 51.6477 46.2821 52.1279 45.9263C52.5998 45.5768 52.9437 45.0416 53.1698 44.1757C53.3978 43.3025 53.4995 42.117 53.4995 40.5V37.25ZM43.4244 38.4528C44.0886 38.4528 44.6269 37.9144 44.6269 37.2503C44.6269 36.5861 44.0886 36.0478 43.4244 36.0478C42.7603 36.0478 42.2219 36.5861 42.2219 37.2503C42.2219 37.9144 42.7603 38.4528 43.4244 38.4528Z",
    fill: "#152C73"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4995 45.1975C53.2572 45.7261 52.9352 46.1373 52.5148 46.4487C51.8982 46.9054 51.1093 47.1175 50.1579 47.2215C49.2109 47.325 48.0589 47.325 46.6914 47.325H46.6745C45.4489 47.325 44.4555 47.3255 43.6414 47.4242C42.8298 47.5226 42.2392 47.7145 41.7994 48.0663C41.3644 48.4143 41.0374 48.9509 40.8199 49.821C40.6011 50.6963 40.4995 51.8836 40.4995 53.5V56.75C40.4995 58.5449 43.4097 60 46.9995 60C50.5894 60 53.4995 58.5449 53.4995 56.75V54.15H47.3245C47.145 54.15 46.9995 54.0045 46.9995 53.825C46.9995 53.6455 47.145 53.5 47.3245 53.5H56.7495C58.5444 53.5 59.9995 50.5899 59.9995 47C59.9995 43.4101 58.5444 40.5 56.7495 40.5H54.1495C54.1495 42.133 54.0481 43.385 53.7987 44.3399C53.7165 44.655 53.6174 44.9401 53.4995 45.1975ZM51.7769 56.7503C51.7769 57.4144 51.2386 57.9528 50.5744 57.9528C49.9103 57.9528 49.3719 57.4144 49.3719 56.7503C49.3719 56.0861 49.9103 55.5478 50.5744 55.5478C51.2386 55.5478 51.7769 56.0861 51.7769 56.7503Z",
    fill: "#D56CCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcNotebookIcon);
export default __webpack_public_path__ + "static/media/calc-notebook-icon.e1b51d22abe03cfd82a8bf0f0ba715b8.svg";
export { ForwardRef as ReactComponent };